import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

import { adminLoginReducer } from "./reducers/adminReducer";
import {
  listRomaniaDescriptionReducer,
  romaniaDescriptionEditReducer,
} from "./reducers/aboutRomaniaReducer";
import {
  listNepalDescriptionReducer,
  nepalDescriptionEditReducer,
} from "./reducers/aboutNepalReducer";

import {
  listConsulsReducer,
  listConsulReducer,
  consulAddReducer,
  consulEditReducer,
  consulDeleteReducer,
} from "./reducers/honararyConsulReducer";

import {
  listVisaDescriptionReducer,
  visaDescriptionEditReducer,
} from "./reducers/visaReducer";

import {
  listEventsReducer,
  listEventReducer,
  eventAddReducer,
  eventEditReducer,
  eventDeleteReducer,
} from "./reducers/eventsReducer";

import {
  listNewsReducer,
  listNewsDetailReducer,
  newsAddReducer,
  newsEditReducer,
  newsDeleteReducer,
} from "./reducers/newsReducer";

import {
  listGalleryReducer,
  galleryDetailReducer,
  galleryAddReducer,
  galleryEditReducer,
  galleryDeleteReducer,
} from "./reducers/galleryReducer";

import {
  listContactUsReducer,
  contactUsEditReducer,
} from "./reducers/contactUsReducer";

const reducer = combineReducers({
  adminLogin: adminLoginReducer,
  listRomaniaDescription: listRomaniaDescriptionReducer,
  romaniaDescriptionEdit: romaniaDescriptionEditReducer,
  listNepalDescription: listNepalDescriptionReducer,
  nepalDescriptionEdit: nepalDescriptionEditReducer,
  listConsuls: listConsulsReducer,
  listConsul: listConsulReducer,
  consulAdd: consulAddReducer,
  consulEdit: consulEditReducer,
  consulDelete: consulDeleteReducer,
  listVisaDescription: listVisaDescriptionReducer,
  visaDescriptionEdit: visaDescriptionEditReducer,
  listEvents: listEventsReducer,
  listEvent: listEventReducer,
  eventAdd: eventAddReducer,
  eventEdit: eventEditReducer,
  eventDelete: eventDeleteReducer,
  listNews: listNewsReducer,
  listNewsDetail: listNewsDetailReducer,
  newsAdd: newsAddReducer,
  newsEdit: newsEditReducer,
  newsDelete: newsDeleteReducer,
  listGallery: listGalleryReducer,
  galleryDetail: galleryDetailReducer,
  galleryAdd: galleryAddReducer,
  galleryEdit: galleryEditReducer,
  galleryDelete: galleryDeleteReducer,
  listContactUs: listContactUsReducer,
  contactUsEdit: contactUsEditReducer,
});

const adminInfoFromStrorage = localStorage.getItem("adminInfo")
  ? JSON.parse(localStorage.getItem("adminInfo"))
  : null;
const initialState = {
  adminLogin: { adminInfo: adminInfoFromStrorage },
};

const middleware = [thunk];
const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);
export default store;
